import ComponentHelper from '../../../supers/ComponentHelper';
import RESTService from '../../../services/RESTService';
import Spinner from '../../../components/spinner/Spinner';
import React from 'react';

const connect = new RESTService();

class UserPermissions extends ComponentHelper {
	constructor(props) {
		super(props);
		this.state = {
			fetchStatus: 'init',
			fetchError: null,
			permissions: []
		};
	}

	componentDidMount() {
		this.setState({ fetchStatus: 'pending', fetchError: null });
		connect
			.getMyPermissions()
			.then(permissions => this.setState({ permissions }))
			.catch(({ message }) => this.setState({ fetchStatus: 'failure', fetchError: message }));
	}

	render() {
		const { fetchStatus, fetchError, permissions } = this.state;

		if (fetchStatus === 'pending') return <Spinner height="273px" text={`Loading user permissions`} />;
		if (fetchStatus === 'failure') return <p className="error-msg">Error: {fetchError}</p>;

		return (
			<div className="user-permissions animated fadeIn">
				<h2>Your permissions</h2>
				{permissions.length > 0 ? <ul>{permissions.map((p, i) => <li key={i}>{p}</li>)}</ul> : <p>You have no permissions.</p>}
			</div>
		);
	}
}

export default UserPermissions;



// WEBPACK FOOTER //
// ./src/views/user-profile/user-permissions/UserPermissions.js